module.exports = "<router-outlet></router-outlet>\n<app-maps></app-maps>\n<app-footer></app-footer>\n"